/** 工作台一级侧栏与导航页配置 */

import { IPE_WORKBENCH_PATH } from '@/config/ipeRoutes';
import { bindCopy } from '@/i18n/bindCopy';

export const HUB_NAV_IDS = new Set([
  'aiTools',
  'workflowHub',
  'platformHub',
  'sheinHub',
  'materialsHub',
  'spaceHub',
]);

export const TOOL_NAV_ITEMS = {
  /** @deprecated 已由 aiCopywriting 替代；保留 id 仅兼容旧深链，进入后应重定向 */
  titles: {
    id: 'titles',
    label: 'AI文案',
    cardDesc: '已迁移至 AI文案',
    bannerTitle: 'AI文案',
    bannerDescription: '标题提取已下线，请使用 AI文案。',
  },
  videos: {
    id: 'videos',
    label: '图生视频',
    cardDesc: '上传商品图，一键生成视频',
    bannerTitle: '图生视频任务中心',
    bannerDescription: '上传商品图，批量生成商品视频。',
  },
  textToVideo: {
    id: 'textToVideo',
    label: '文生视频',
    cardDesc: '输入描述，一键生成商品视频',
    bannerTitle: '文生视频任务中心',
    bannerDescription: '输入文字描述，一键生成商品视频。',
  },
  modelTryOn: {
    id: 'modelTryOn',
    label: '模特试衣',
    cardDesc: 'AI 虚拟模特试穿，省去实拍成本',
    bannerTitle: '模特试衣',
    bannerDescription: '上传模特图与服饰图，AI 虚拟试穿生成自然上身效果，省去实拍成本。',
  },
  modelHandheld: {
    id: 'modelHandheld',
    label: '手持商品',
    cardDesc: '模特自然手持商品，提升展示真实感',
    bannerTitle: '手持商品',
    bannerDescription: '为模特智能合成手持商品效果，保持模特姿态与商品外观一致。',
  },
  modelPoseFission: {
    id: 'modelPoseFission',
    label: '姿势裂变',
    cardDesc: '同一模特同款服装，一键生成多姿势',
    bannerTitle: '姿势裂变',
    bannerDescription: '基于一张模特图裂变生成多种姿势变体，服装与模特身份保持一致。',
  },
  modelUniversalWear: {
    id: 'modelUniversalWear',
    label: '万物穿戴',
    cardDesc: '服装平铺或人台图，一键上身展示',
    bannerTitle: '万物穿戴',
    bannerDescription: '将服装素材智能穿戴到 AI 模特身上，款式与细节保持一致。',
  },
  imageCrop: {
    id: 'imageCrop',
    label: '图案裁剪',
    cardDesc: '智能识别图案区域，快速裁剪调整',
    bannerTitle: '图案裁剪工具',
    bannerDescription: '智能识别图案区域，快速裁剪并调整尺寸与比例。',
  },
  imageEnhance: {
    id: 'imageEnhance',
    label: '超分提质',
    cardDesc: 'AI 高清放大，图案清晰不模糊',
    bannerTitle: '超分提质',
    bannerDescription: '基于 qwen-image-2.0 对低清商品图做清晰化提质，参数由系统统一配置。',
  },
  smartCutout: {
    id: 'smartCutout',
    label: '智能抠图',
    cardDesc: 'AI 智能识别并抠取图片主体',
    bannerTitle: '智能抠图工具',
    bannerDescription: '可选基础（阿里云分割）或高级（千问白底 + BRIA RMBG-1.4 去白底），输出透明 PNG。',
  },
  imageFission: {
    id: 'imageFission',
    label: '图片裂变',
    cardDesc: '白板商品图裂变生成同品多场景图',
    bannerTitle: '图片裂变 · 印花设计',
    bannerDescription:
      '从素材推荐或本地上传原图进行 AI 图裂变；产出写入 AI 灵感待发布（含 IPE 水印），审核后对用户可见。',
  },
  img2img: {
    id: 'img2img',
    label: '万能改图',
    cardDesc: '修改指令 + 目标图片智能改图',
    bannerTitle: '万能改图',
    bannerDescription:
      '上传待改图的目标图片并填写修改指令，按指令智能改图；推荐从「素材推荐」选择目标图，产出写入 AI 灵感待发布（含 IPE 水印）。',
  },
  aiOutpaint: {
    id: 'aiOutpaint',
    label: 'AI扩图',
    cardDesc: '智能扩展画布，补全背景与构图',
    bannerTitle: 'AI扩图',
    bannerDescription: '在保持商品主体不变的前提下，智能向外扩展画面与背景。',
  },
  aiTextToImage: {
    id: 'aiTextToImage',
    label: '文生图',
    cardDesc: '输入文字描述，AI生成高质量图片',
    bannerTitle: '文生图',
    bannerDescription: '根据文字提示词生成高质量图片，支持多种风格与场景，快速产出创意素材。',
  },
  aiCopywriting: {
    id: 'aiCopywriting',
    label: 'AI文案',
    cardDesc: '智能生成商品标题与卖点文案',
    bannerTitle: 'AI文案',
    bannerDescription: '根据商品信息自动生成标题、卖点与详情文案，适配多平台上架需求。',
  },
  goods: {
    id: 'goods',
    label: '主图创作',
    cardDesc: '批量创作主图，一键上架',
    bannerTitle: '主图创作任务中心',
    bannerDescription: '批量创作主图，监控任务进度与出图质量，支持快速编辑与导出。',
  },
  podProductDesign: {
    id: 'podProductDesign',
    label: 'POD商品设计',
    cardDesc: '模板套图快速合成 POD 商品展示图',
    bannerTitle: 'POD商品设计',
    bannerDescription: '选择套图模板与印花素材，批量合成 POD 商品展示图，支持快速编辑与导出。',
  },
  stampExtract: {
    id: 'stampExtract',
    label: '印花提取',
    cardDesc: 'AI 精准提取印花图案素材',
    bannerTitle: '印花提取工具',
    bannerDescription: '基于 qwen-image-2.0 从商品图中识别并提取印花图案，输出透明 PNG 素材；推荐上传印花特写或平铺图，效果更佳。',
  },
  patternFission: {
    id: 'patternFission',
    label: '图案裂变',
    cardDesc: '单张图案裂变多款印花变体',
    bannerTitle: '图案裂变',
    bannerDescription: '基于一张印花图案裂变生成多种风格与配色变体，快速扩充 POD 素材库。',
  },
  imageCollection: {
    id: 'imageCollection',
    label: '素材采集',
    cardDesc: '浏览器插件抓取货源与 Listing',
    bannerTitle: '插件采集与选品',
    bannerDescription:
      '使用浏览器插件在各货源站、找图站抓取整页商品图与 Listing，上报入库并自动打分；在候选分析中筛选后送入待上品，可直接上品或继续抠图、贴图、标题提取与主图创作。',
  },
  thirdPartyReceive: {
    id: 'thirdPartyReceive',
    label: '第三方商品库',
    cardDesc: '接收第三方推送的印花、主图、细节图与标题',
    bannerTitle: '第三方商品库',
    bannerDescription:
      '通过 IPE Key 接收第三方推送商品，自动下载图片入库个人/团队空间；可查看印花图、主图、细节图与标题，并在本页继续 AI 文案、侵权检测与自动上架。',
  },
  infringementDetection: {
    id: 'infringementDetection',
    label: '侵权检测',
    cardDesc: '批量检测图片侵权风险',
    bannerTitle: '侵权风险过滤',
    bannerDescription:
      '批量检测图片侵权风险，支持基础/深度过滤模式；由 qwen3.6-plus 多模态模型分析，任务列表、详情与风险等级展示。',
  },
  imageTemplates: {
    id: 'imageTemplates',
    label: '套图模板',
    cardDesc: '沉淀高转化套图模板，按场景分类',
    bannerTitle: '套图模板库',
    bannerDescription: '沉淀高转化套图模板，按场景、款式、店铺分类，方便运营快速查询并调用。',
  },
  tableTemplates: {
    id: 'tableTemplates',
    label: '表格模板',
    cardDesc: '管理各平台批量上架 Excel 表格模板',
    bannerTitle: '表格模板库',
    bannerDescription: '上传并维护 TEMU、SHEIN、店小秘等平台官方表格模板，用于导出与批量上款。',
  },
  listingTemplates: {
    id: 'listingTemplates',
    label: '刊登模板',
    cardDesc: '配置平台直接上架字段与规则',
    bannerTitle: '刊登模板库',
    bannerDescription: '配置各平台直接上架所需的字段、规格与刊登规则，供本地商品库一键刊登使用。',
  },
  systemMaterialLibrary: {
    id: 'systemMaterialLibrary',
    label: '素材中心',
    cardDesc: '浏览官方精选印花与设计素材',
    bannerTitle: '素材中心',
    bannerDescription:
      '搜索、分类浏览 POD 印花与设计素材，收藏心仪作品并一键导入图片空间，用于套图与工作流。',
  },
  sourcingHub: {
    id: 'sourcingHub',
    label: '插件采集',
    cardDesc: '浏览器插件抓取货源与 Listing',
    bannerTitle: '插件采集与选品',
    bannerDescription:
      '使用浏览器插件在各货源站、找图站抓取整页商品图与 Listing，上报入库并自动打分；在候选分析中筛选后送入待上品，可直接上品或继续抠图、贴图、标题提取与主图创作。',
  },
  imageSpace: {
    id: 'imageSpace',
    label: '图片空间',
    cardDesc: '云端图片存储与管理',
    bannerTitle: '图片空间库',
    bannerDescription: '图片空间是云端图片存储管理工，支持图片上传管理与便捷查看，轻松打理商品素材',
  },
  spaceVideo: {
    id: 'spaceVideo',
    label: '视频空间',
    cardDesc: '云端视频存储与管理',
    bannerTitle: '视频空间库',
    bannerDescription: '集中管理图生视频、文生视频等任务产出，支持预览、回收站与文件夹整理。',
  },
  spaceCollection: {
    id: 'spaceCollection',
    label: '采集空间',
    cardDesc: '插件采集与脚本入库的图片',
    bannerTitle: '采集空间',
    bannerDescription: '查看与管理来自插件采集、用户采集、定时采集等渠道入库的图片素材。',
  },
  platformShops: {
    id: 'platformShops',
    label: '店铺管理',
    cardDesc: '电商平台店铺授权与管理',
    bannerTitle: '电商平台店铺',
    bannerDescription:
      '1688 店铺通过「应用授权」对接开放平台 OAuth，换票后写入真实 memberId 与 access_token；淘宝等平台待接入。模拟授权（MOCK-*）不可用于真实上架 API。',
  },
  platformListing: {
    id: 'platformListing',
    label: '本地商品库',
    cardDesc: '将待刊登商品入库并管理主图、详情图与刊登状态。',
    bannerTitle: '本地商品库',
    bannerDescription:
      '从其它功能带入的商品按入库批次管理：批次列表进入详情，详情中点击查看可浏览印花图、主图与细节图。可配置自动规则，入库后自动上架到所选店铺。',
  },
  platformProducts: {
    id: 'platformProducts',
    label: '产品管理',
    cardDesc: '已发布平台产品与核价状态',
    bannerTitle: '产品管理',
    bannerDescription:
      '查看通过 API 刊登或从 SHEIN 同步的已发布产品，支持刷新平台核价状态、供货价与审核信息；类似店小秘的已刊登产品台账。',
  },
  platformListingJobs: {
    id: 'platformListingJobs',
    label: '刊登任务',
    cardDesc: '查看 API 刊登任务进度与明细行状态',
    bannerTitle: '刊登任务',
    bannerDescription:
      '查看本地商品库发起的 API 刊登任务：按批次管理，详情中一 SPU 一行展示推送状态与平台返回日志。',
  },
  platformScheduledListings: {
    id: 'platformScheduledListings',
    label: '定时上架',
    cardDesc: '查看待到点执行的定时上架队列',
    bannerTitle: '定时上架',
    bannerDescription:
      '自动规则选择「定时上架」或开启「间隔上架」后，预检通过的商品会进入本队列；到点后自动创建刊登任务并推送 SHEIN。间隔上架时每个 SPU 一条记录、按设定间隔错开执行。',
  },
  ipeWorkflow: {
    id: 'ipeWorkflow',
    label: '工作流模板',
    cardDesc: '编排可复用的自动化工作流',
    bannerTitle: '工作流模板',
    bannerDescription:
      '将插件采集与印花提取、抠图、主图创作、标题提取等编排为可复用模板；保存后在插件采集「应用工作流」或进入各工具执行。',
  },
  ipeWorkflowTasks: {
    id: 'ipeWorkflowTasks',
    label: '工作流任务',
    cardDesc: '查看排队与执行中的工作流',
    bannerTitle: '工作流任务',
    bannerDescription:
      '查看排队与执行中的工作流任务，支持同时运行多个流程；关闭执行页后任务仍在后台继续。',
  },
  downloadCenter: {
    id: 'downloadCenter',
    label: '下载中心',
    cardDesc: '查看导出与批量下载记录',
    bannerTitle: '下载中心',
    bannerDescription: '查看按模版导出、批量下载等任务的文件记录与进度。',
  },
  spaceFavorites: {
    id: 'spaceFavorites',
    label: '我的收藏',
    cardDesc: '收藏的图片素材',
    bannerTitle: '我的收藏',
    bannerDescription: '查看与管理已收藏的图片素材。',
  },
  spaceTrash: {
    id: 'spaceTrash',
    label: '回收站',
    cardDesc: '已删除的图片',
    bannerTitle: '回收站',
    bannerDescription: '已删除的图片暂存于此，可恢复或彻底删除。',
  },
  teamManagement: {
    id: 'teamManagement',
    label: '团队管理',
    cardDesc: '邀请成员共享套餐额度',
    bannerTitle: '团队管理',
    bannerDescription: '查看权限、邀请成员共享套餐额度，处理加入申请。',
  },
  accountCenter: {
    id: 'accountCenter',
    label: '账号中心',
    cardDesc: '管理账户资料、密码与套餐',
    bannerTitle: '账号中心',
    bannerDescription: '管理账户资料、密码与套餐用量。',
  },
  orderCenter: {
    id: 'orderCenter',
    label: '账单中心',
    cardDesc: '充值订单与 IPE 豆消耗流水',
    bannerTitle: '账单中心',
    bannerDescription: '查看充值订单与消耗流水，标明扣的是个人还是团队。',
  },
  openKeys: {
    id: 'openKeys',
    label: '开放对接',
    cardDesc: 'IPE Key 与第三方推送接入',
    bannerTitle: '开放对接 · IPE Key',
    bannerDescription: '管理个人/团队 IPE Key，供第三方系统按 imagefList 推送印花图、主图、细节图与标题。',
  },
};

export const NAV_HUBS = {
  aiTools: {
    id: 'aiTools',
    label: '智能工具',
    sections: [
      {
        title: 'AI图片',
        items: [
          'img2img',
          'imageFission',
          'aiOutpaint',
          'aiTextToImage',
        ],
      },
      {
        title: 'AI模特',
        items: ['modelTryOn', 'modelHandheld', 'modelPoseFission', 'modelUniversalWear'],
      },
      {
        title: 'AI视频',
        items: ['videos', 'textToVideo'],
      },
      {
        title: 'POD工具',
        items: [
          'podProductDesign',
          'goods',
          'imageCrop',
          'stampExtract',
          'smartCutout',
          'imageEnhance',
          'aiCopywriting',
          'imageCollection',
        ],
      },
      {
        title: 'POD刊登',
        items: ['platformListing', 'thirdPartyReceive', 'platformListingJobs', 'platformScheduledListings'],
      },
      {
        title: '侵权检测',
        items: ['infringementDetection'],
      },
    ],
  },
  workflowHub: {
    id: 'workflowHub',
    label: '工作流',
    sections: [
      {
        title: '工作流',
        items: ['ipeWorkflow', 'ipeWorkflowTasks'],
      },
    ],
  },
  platformHub: {
    id: 'platformHub',
    label: '平台管理',
    sections: [
      {
        title: '平台管理',
        items: ['platformShops', 'imageTemplates'],
      },
    ],
  },
  sheinHub: {
    id: 'sheinHub',
    label: '电商平台',
    cardDesc: '选择 SHEIN / TEMU 进入对应平台工作区',
    openInNewTab: false,
    workspacePath: '/ipe/commerce',
  },
  materialsHub: {
    id: 'materialsHub',
    label: '素材',
    sections: [
      {
        title: '素材中心',
        items: ['systemMaterialLibrary'],
      },
    ],
  },
  spaceHub: {
    id: 'spaceHub',
    label: '空间',
    sections: [
      {
        title: '我的空间',
        items: ['imageSpace', 'spaceVideo', 'spaceFavorites', 'downloadCenter', 'spaceTrash'],
      },
    ],
  },
};

/** 扁平化工具项（向后兼容） */
export const NAV_ITEMS = Object.values(TOOL_NAV_ITEMS);

/** 旧版分组结构（向后兼容，供部分逻辑引用） */
export const NAV_GROUPS = Object.values(NAV_HUBS).map((hub) => ({
  id: hub.id,
  get label() {
    return hub.label;
  },
  children: (hub.sections || []).flatMap((s) =>
    s.items.map((id) => TOOL_NAV_ITEMS[id]).filter(Boolean)
  ),
}));

export function isHubNavId(navId) {
  return HUB_NAV_IDS.has(navId);
}

/** 工作流中心（双 Tab 页，非导航卡片） */
export function isWorkflowSectionNav(navId) {
  return navId === 'workflowHub' || navId === 'ipeWorkflow' || navId === 'ipeWorkflowTasks';
}

/** 平台管理中心（多 Tab 页，非导航卡片） */
export function isPlatformSectionNav(navId) {
  return navId === 'platformHub'
    || navId === 'platformShops'
    || navId === 'tableTemplates'
    || navId === 'imageTemplates'
    || navId === 'listingTemplates';
}

/**
 * 多 Tab 壳层（平台管理 / 工作流 / 空间等）：子 Tab 的 activeNav 不是 hub id，
 * 但仍需与 hub 入口共用 flex 铺满布局（避免 :has(.funding-nav-hub) 把 nav-section 压成内容高度）。
 */
export function usesWorkbenchHubShellLayout(navId) {
  return (
    isHubNavId(navId)
    || isPlatformSectionNav(navId)
    || isWorkflowSectionNav(navId)
    || isSpaceSectionNav(navId)
  );
}

/** POD 刊登相关页面（商品库、刊登任务、第三方任务） */
export function isPodListingNav(navId) {
  return navId === 'platformListing'
    || navId === 'platformListingJobs'
    || navId === 'platformScheduledListings'
    || navId === 'thirdPartyReceive';
}

/** 旧版产品管理入口，兼容重定向至 SHEIN 工作区 */
export function isLegacySheinProductNav(navId) {
  return navId === 'platformProducts';
}

/** 空间中心（Tab 页，非导航卡片） */
export function isSpaceSectionNav(navId) {
  return (
    navId === 'spaceHub'
    || navId === 'imageSpace'
    || navId === 'spaceCollection'
    || navId === 'spaceVideo'
    || navId === 'spaceFavorites'
    || navId === 'spaceTrash'
    || navId === 'downloadCenter'
  );
}

/** 兼容旧版 hub id（如 crossBorderTools 已拆分为 workflowHub / platformHub） */
export function normalizeWorkbenchNavId(navId) {
  // 标题提取已下线，历史入口统一跳转到 AI文案
  if (navId === 'titles' || navId === 'titleExtract') return 'aiCopywriting';
  if (navId === 'crossBorderTools') return 'workflowHub';
  if (navId === 'imageTools') return 'aiTools';
  if (navId === 'spaceCollection') return 'imageSpace';
  if (navId === 'imageCollection') return 'sourcingHub';
  if (navId === 'materialsHub') return 'systemMaterialLibrary';
  if (navId === 'templatesHub' || navId === 'imageTemplates') return 'imageTemplates';
  if (navId === 'productReplica' || navId === 'aiProductMarketing') return 'aiTools';
  // 标题提取已下线，统一落 AI 文案
  if (navId === 'titles' || navId === 'titleExtract') return 'aiCopywriting';
  if (navId === 'goodsTemplates' || navId === 'tableTemplates') return 'imageTemplates';
  if (navId === 'listingTemplates' && typeof localStorage !== 'undefined') {
    const migrated = localStorage.getItem('ipe-platform-template-nav-migrated-v2');
    if (!migrated) {
      localStorage.setItem('ipe-platform-template-nav-migrated-v2', '1');
      return 'imageTemplates';
    }
  }
  return navId;
}

/** 素材采集卡片 id 与内容页 activeNav（sourcingHub）的对应关系 */
export function resolveToolMenuLookupNavId(navId) {
  if (navId === 'sourcingHub') return 'imageCollection';
  return navId;
}

export function isSameToolNavId(activeNav, itemNavId) {
  if (!activeNav || !itemNavId) return false;
  if (activeNav === itemNavId) return true;
  return (
    (activeNav === 'sourcingHub' && itemNavId === 'imageCollection')
    || (activeNav === 'imageCollection' && itemNavId === 'sourcingHub')
  );
}

export function getHubIdForNav(navId) {
  if (navId === 'podProductDesign') return 'aiTools';
  const lookupId = resolveToolMenuLookupNavId(navId);
  for (const hub of Object.values(NAV_HUBS)) {
    for (const section of hub.sections || []) {
      if (section.items.includes(lookupId)) return hub.id;
    }
  }
  return null;
}

export function getSidebarActiveId(activeNav) {
  if (activeNav === 'workbenchHome') return 'workbenchHome';
  if (isHubNavId(activeNav)) return activeNav;
  const hubId = getHubIdForNav(activeNav);
  if (hubId) return hubId;
  return 'workbenchHome';
}

/** 智能工具：进入具体功能后，侧栏由卡片入口切换为分组功能菜单 */
export function getToolMenuHubId(activeNav) {
  if (!activeNav || activeNav === 'aiTools') return null;
  const hubId = getHubIdForNav(activeNav);
  return hubId === 'aiTools' ? hubId : null;
}

/** 查找工具所属的分组（如 AI图片、AI模特） */
export function getHubSectionForNav(navId, hubId = 'aiTools') {
  const hub = NAV_HUBS[hubId];
  if (!hub) return null;
  const lookupId = resolveToolMenuLookupNavId(navId);
  return (hub.sections || []).find((section) => section.items.includes(lookupId)) ?? null;
}

export function resolveNavItem(navId) {
  return TOOL_NAV_ITEMS[navId] ?? null;
}

/** 有独立 pathname 的工具（与 IpeWorkbench pathToNav 保持一致） */
export const WORKBENCH_TOOL_PATH_BY_NAV = {
  imageCrop: `${IPE_WORKBENCH_PATH}/image-crop`,
  imageEnhance: `${IPE_WORKBENCH_PATH}/image-enhance`,
  smartCutout: `${IPE_WORKBENCH_PATH}/smart-cutout`,
  stampExtract: `${IPE_WORKBENCH_PATH}/stamp-extract`,
  modelTryOn: `${IPE_WORKBENCH_PATH}/model-try-on`,
};

export const WORKBENCH_HOME_NAV_ID = 'workbenchHome';

/** 按标签页隔离的工作台导航持久化（避免多窗口互相覆盖） */
export const WORKBENCH_ACTIVE_NAV_SESSION_KEY = 'ipe-workbench-active-nav';

/** @deprecated 旧版跨标签共享 key，仅作一次性迁移来源 */
export const LEGACY_WORKBENCH_ACTIVE_NAV_STORAGE_KEY = 'funding-workbench-active-nav';

export const WORKBENCH_PATH_TO_NAV = Object.fromEntries(
  Object.entries(WORKBENCH_TOOL_PATH_BY_NAV).map(([navId, path]) => [path, navId]),
);

export function isValidWorkbenchNavId(navId) {
  if (!navId) return false;
  if (navId === WORKBENCH_HOME_NAV_ID) return true;
  if (isHubNavId(navId)) return true;
  if (NAV_ITEMS.some((item) => item.id === navId)) return true;
  return Object.values(WORKBENCH_PATH_TO_NAV).includes(navId);
}

function coerceWorkbenchNavId(navId) {
  const normalized = normalizeWorkbenchNavId(navId);
  return isValidWorkbenchNavId(normalized) ? normalized : null;
}

function readSessionWorkbenchNav() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    return coerceWorkbenchNavId(sessionStorage.getItem(WORKBENCH_ACTIVE_NAV_SESSION_KEY));
  } catch {
    return null;
  }
}

/** 从 pathname / ?activeNav= 解析当前模块（各标签页 URL 互不干扰） */
export function resolveNavFromWorkbenchLocation({ pathname = '', search = '' } = {}) {
  const navFromPath = coerceWorkbenchNavId(WORKBENCH_PATH_TO_NAV[pathname]);
  if (navFromPath) return navFromPath;
  return coerceWorkbenchNavId(new URLSearchParams(search || '').get('activeNav'));
}

/** 构建工作台模块 URL（与 buildWorkbenchToolUrl 一致，供页内跳转同步地址栏） */
export function buildWorkbenchNavUrl(navId, { search = '' } = {}) {
  const resolved = coerceWorkbenchNavId(navId);
  if (!resolved) {
    return `${IPE_WORKBENCH_PATH}?activeNav=${WORKBENCH_HOME_NAV_ID}`;
  }
  const toolPath = WORKBENCH_TOOL_PATH_BY_NAV[resolved];
  if (toolPath) return toolPath;
  const sp = new URLSearchParams(search || '');
  sp.set('activeNav', resolved);
  const qs = sp.toString();
  return `${IPE_WORKBENCH_PATH}?${qs}`;
}

/** 智能工具卡片等新标签页打开时的目标 URL */
export function buildWorkbenchToolUrl(navId) {
  return buildWorkbenchNavUrl(normalizeWorkbenchNavId(navId));
}

/**
 * 跳转到工作台指定模块并写入 location.state（同步 URL 中的 activeNav，避免与当前 query 冲突）
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {string} navId
 * @param {Record<string, unknown>} [extraState]
 * @param {{ replace?: boolean, openInNewTab?: boolean }} [options]
 */
export function navigateWorkbenchWithState(
  navigate,
  navId,
  extraState = {},
  { replace = false, openInNewTab = false } = {},
) {
  const resolved = coerceWorkbenchNavId(normalizeWorkbenchNavId(navId));
  if (!resolved) return;
  const url = buildWorkbenchNavUrl(resolved);
  const state = { ...extraState, activeNav: resolved };
  if (openInNewTab) {
    // 延迟加载，避免本文件顶层依赖 handoff 触发与 aiStudioConfig / image-crop 的循环初始化
    // eslint-disable-next-line global-require, import/no-dynamic-require
    require('../utils/workbenchNavHandoff').openWorkbenchUrlWithState(url, state);
    return;
  }
  if (typeof navigate !== 'function') return;
  navigate(url, {
    replace,
    state,
  });
}

/** 解析当前标签页应展示的工作台导航（URL 优先，session 仅作 /ipe 无参时的回退） */
export function resolveInitialWorkbenchNav({ pathname = '', search = '', state = null } = {}) {
  const navFromUrl = resolveNavFromWorkbenchLocation({ pathname, search });
  if (navFromUrl) return navFromUrl;

  const navFromState = coerceWorkbenchNavId(state?.activeNav);
  if (navFromState) return navFromState;

  const navFromSession = readSessionWorkbenchNav();
  if (navFromSession) return navFromSession;

  return WORKBENCH_HOME_NAV_ID;
}

export function persistWorkbenchNav(navId) {
  const resolved = coerceWorkbenchNavId(navId);
  if (!resolved || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(WORKBENCH_ACTIVE_NAV_SESSION_KEY, resolved);
  } catch {
    /* ignore quota / private mode */
  }
}

/** 侧栏一级入口对应的 keep-alive 分区 key */
export const SIDEBAR_SECTION_KEYS = Object.freeze({
  home: 'home',
  aiTools: 'aiTools',
  workflow: 'workflow',
  platform: 'platform',
  materials: 'materials',
  space: 'space',
});

/** 将 activeNav 映射到侧栏一级分区（具体工具页返回 null） */
export function resolveSidebarSectionKey(activeNav) {
  if (activeNav === WORKBENCH_HOME_NAV_ID) return SIDEBAR_SECTION_KEYS.home;
  if (activeNav === 'aiTools') return SIDEBAR_SECTION_KEYS.aiTools;
  if (isWorkflowSectionNav(activeNav)) return SIDEBAR_SECTION_KEYS.workflow;
  if (isPlatformSectionNav(activeNav)) return SIDEBAR_SECTION_KEYS.platform;
  if (activeNav === 'systemMaterialLibrary') return SIDEBAR_SECTION_KEYS.materials;
  if (isSpaceSectionNav(activeNav)) return SIDEBAR_SECTION_KEYS.space;
  return null;
}

const SECTION_TITLE_KEY = {
  AI图片: 'section.aiImage',
  AI模特: 'section.aiModel',
  AI视频: 'section.aiVideo',
  POD工具: 'section.podTools',
  POD刊登: 'section.podListing',
  侵权检测: 'section.infringement',
  工作流: 'section.workflow',
  平台管理: 'section.platform',
  素材中心: 'section.materials',
  我的空间: 'section.mySpace',
};

Object.entries(TOOL_NAV_ITEMS).forEach(([id, item]) => {
  bindCopy(item, `nav.${id}`, ['label', 'cardDesc', 'bannerTitle', 'bannerDescription']);
});

Object.entries(NAV_HUBS).forEach(([id, hub]) => {
  bindCopy(hub, `hub.${id}`, ['label', 'cardDesc']);
  (hub.sections || []).forEach((section) => {
    const titleKey = SECTION_TITLE_KEY[section.title];
    if (!titleKey) return;
    section.titleKey = titleKey;
    bindCopy(section, titleKey, ['title']);
  });
});
